
const MenuItem = props => {
    const { data } = props
    return <div className="item" data-url={data.key}>
        {data.label}
    </div>
}

const MenuContent = props => {
    const { menu, onClick } = props

    return <div className="menu-content" onClick={onClick}>
        {menu.map((i, ix) => <MenuItem data={i} key={ix} />)}
    </div>
}

export default MenuContent
